import { Outlet } from "react-router-dom";

const SettingsMainPage = () => {
    return <Outlet />;
}

export default SettingsMainPage;